import { render, staticRenderFns } from "./PhoneOption.vue?vue&type=template&id=215fea5e&scoped=true&"
import script from "./PhoneOption.vue?vue&type=script&lang=ts&"
export * from "./PhoneOption.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneOption.vue?vue&type=style&index=0&id=215fea5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215fea5e",
  null
  
)

export default component.exports